import { css } from '@emotion/react';

import { colors, fontSizes, space } from '../shared/styles';

export const navigationStyles = css`
  overflow-x: auto;
  overscroll-behavior-inline: contain;
  scrollbar-width: thin;
`;

export const listStyles = css`
  align-items: center;
  display: flex;
  gap: ${space[2]};
  list-style: none;
  margin: 0;
  min-width: max-content;
  padding: ${space[2]} 0;
`;

export const itemStyles = css`
  align-items: center;
  color: ${colors.gray[700]};
  display: flex;
  font-size: ${fontSizes.sm};
  gap: ${space[2]};

  &[aria-current='page'] {
    color: ${colors.gray[900]};
    font-weight: 600;
  }
`;

export const separatorStyles = css`
  color: ${colors.gray[400]};
  user-select: none;
`;
